import axios from "axios";
import {IJob} from "../../../pages/jobs-management/models/IJob";
import {IUser} from "../../../pages/user-management/models/User";
import {makeRequest} from "../../../utils/helpers/helperMethods/makeRequest";
import {ILead} from "../../../pages/leads-management/models/ILead";
import {Job} from "../jobManagementSlice";
import { CreateJobParams, DeleteJobParams, GetAllJobsParams, GetCustomerJobs, GetSingleJobParams } from "../types";


export async function getAllJobs(
   {OrderBy,PageNumber,PageSize,ParameterOne,ParameterThree,ParameterTwo,SearchText,SortOrder,accessToken,url} : GetAllJobsParams
) {
    try {
        let endpoint = `${url}/jobs?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchText=${SearchText}&OrderBy=${OrderBy}&SortOrder=${SortOrder}&ParameterOne=${ParameterOne}&ParameterTwo=${ParameterTwo}`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return response.json();
        }else {
            throw new Error("Jobs get Failed");
        }
    } catch (e) {
        throw new Error("Jobs get Failed");
    }
}

export async function getJobById( {accessToken,url} : GetSingleJobParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'GET', null, ''));
        if (response.ok){
            return  response.json();
        }else {
            throw new Error("Job get Failed");
        }
    } catch (e) {
        throw new Error("Job get Failed");
    }
}

export async function CreateJob( {accessToken,job,url}: CreateJobParams ) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'POST',job, ''));
        if (response.ok){
            return response.json();
        }else {
            throw new Error("Job create failed");
        }
    }catch (e) {
        throw "Job create failed"
    }
}

export async function EditJob( {accessToken,job,url}: CreateJobParams ) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'PUT',job, ''));
        if (response.ok){
            return {message:'Job Updated', success:true};
        }else {
            throw new Error("Job create failed");
        }
    }catch (e) {
        throw "Job create failed"
    }
}



export async function DeleteJob({accessToken,id,url}: DeleteJobParams) {
    try {
        const response = await  ( await  makeRequest(accessToken, url, 'DELETE',id, ''));
        if (response.ok){
            return {message:'Job Deleted', success:true};
        }else {
            throw new Error("Job delete failed");
        }
    }catch (e) {
        throw "Job delete failed"
    }
}


export async function getCustomerJobs( {accessToken,url, id}: GetCustomerJobs) {
    try {
        const endpoint = `${url}/users/customers/${id}/jobs`;
        const response = await  ( await  makeRequest(accessToken, endpoint, 'GET', null, ''));
        if (response.ok){
            return await response.json();
        }else {
            throw new Error("Count get Failed");
        }
    } catch (e) {
        throw new Error("Count get Failed");
    }
}
